import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Products from '../components/Products';
import WhyChooseUs from '../components/WhyChooseUs';
import StatsSection from '../components/StatsSection';
import CTASection from '../components/CTASection';
import WelcomeSection from '../components/WelcomeSection';
import ClientSlider from '../components/ClientSlider';
import CertificateSection from '../components/CertificateSection';

const Home = () => {
    // Hum API call ko Hero.jsx ke andar handle kar rahe hain,
    // isliye yahan extra code ki zaroorat nahi hai.
    return (
        <>
            <Hero />
            <About />
            <Products />
            <WhyChooseUs />
            <ClientSlider />
            <WelcomeSection />
            <StatsSection />
            <CTASection />
            <CertificateSection />
        </>
    );
};

export default Home;